import React from 'react';
import TableRow from '@mui/material/TableRow';
import './GenericTable.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getSafe } from '../../../shared/utility';

const Row = (props) => {
	const { selectedRowStatePath, setSelectedRow } = props;
	const dispatch = useDispatch();
	const selectedRow = useSelector((state) => selectedRowStatePath ? getSafe(selectedRowStatePath ,state) : null);
	const onRowClick = () => {
		if (setSelectedRow) {
			dispatch(setSelectedRow(props.tableRow.rowId));
		}
	};
	return (
		<TableRow 
			className={selectedRow == props.tableRow.rowId ? 'row-selected' : ''}
			onClick={onRowClick}
		>
			{props.children}
		</TableRow>
	);
};

export default Row;
